module.exports = __webpack_public_path__ + "static/media/20ECE31.a6e6d5b2.jpg";